<template>
  <a :href="entryLink?.url" class="col-12 teaser-xl-block" :style="image?.url ? { backgroundImage: `url(${image.url})` } : {}">

    <div class="teaser-xl-content">
      <p v-if="heading" class="text-lg text-center text-uppercase">
        {{ heading }}
      </p>

      <p v-if="text" class="text-sm text-family-secondary">
        {{ text }}
      </p>

      <router-link v-if="entryLink?.url" :to="entryLink?.url" class="btn-icon-right mt-2"></router-link>
    </div>
  </a>
</template>

<script setup>
defineProps({
  heading: { type: String, default: null },
  text: { type: String, default: null },
  entryLink: { type: Object, default: null },
  image: { type: Object, default: null }
})
</script>